import { TrailId } from 'types/Trails';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import apiRequest from './requestBase';

// API under app/controllers/api/alltrails/default/trails/props_controller

export default async function getTrailProps(trailId: TrailId, languageRegionCode: LanguageRegionCode, explore?: boolean) {
  return apiRequest({
    params: {
      explore
    },
    headers: {
      'X-Language-Locale': languageRegionCode
    },
    url: `/api/alltrails/trails/${trailId}/props`
  });
}
